import React, { useState, useEffect, useMemo } from 'react'
import Select2 from 'react-select'
import destinationStore from '../stores/destination'
import regionStore from '../stores/region'
import cn from '@/../lib/cn'
import Table from '@/../components/Table'
import { produce } from 'immer'
import Button from '@/../components/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro' // <-- import styles to be used
import { Text } from '@/../components/Fields'

export default function ({onChange, value, allowDeleteLast = false}) {

  const [autoSplit, setAutoSplit] = useState(value.length == 0)
  const axe = icon({ name: 'axe' })

  const [regions] = regionStore(state => [state.collection])

  function splitEvenly() {
    setAutoSplit(true)
    onChange(produce(value ?? [], draft => {
      let remaining = 100
      let newPercentage = 0
      const length = draft.filter(dt => !dt['_destroy']).length
      let foundIndex = 0
      for (let i = 0; i < draft.length; i++) {
        if (!draft[i]['_destroy']) {
          newPercentage = Math.floor(remaining / parseFloat(length - foundIndex))
          draft[i].percentage = newPercentage
          foundIndex++
          remaining -= newPercentage
        }
      }
    }))
  }

  useEffect(() => {
    console.log('value changed', value)
    if (autoSplit && value.length > 0 && value.some(dt => !dt.percentage)) {
      splitEvenly()
    }
  }, [value.length])

  return <>
    <div className="flex gap-4 justify-between mb-6">
      <Button
        disabled={value?.length < 1}
        onClick={splitEvenly}
      >
        <FontAwesomeIcon icon={icon({name: "axe"})} className="mr-2" />
        Split Evenly
      </Button>
      <Button onClick={() => {
        const newValue = produce(value, draft => {
          draft.push({ id: null, destination_id: '', percentage: '' })
        })
        onChange(newValue)
      }}>
        <FontAwesomeIcon icon={icon({name: "plus"})} className="mr-2" />
        Add Destination
      </Button>
    </div>
    <Table className="mb-6">
      <Table.Head>
        <Table.Row>
          <Table.Th>Destination</Table.Th>
          <Table.Th width="80">Percentage</Table.Th>
          {((value?.length > 1) || allowDeleteLast) && <Table.Th width="40"></Table.Th>}
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {!value?.length && <Table.Row>
          <Table.Td className="text-center text-red-500 font-bold" colSpan="3">
            No destinations
          </Table.Td>
        </Table.Row>}
        {value?.map((dt, index) => {
          if (dt._destroy) return null
          return <Table.Row key={index}>
            <Table.Td>
              <Select
                onChange={destination => onChange(produce(value, draft => {
                  draft[index].destination_id = destination?.value
                }), destination)}
                value={dt.destination_id}
              />
            </Table.Td>
            <Table.Td width="80">
              <Text
                type="number"
                value={dt.percentage}
                onChange={e => {
                  setAutoSplit(false)
                  onChange(produce(value, draft => {
                    draft[index].percentage = e.target.value
                  }))
                }}
                groupClass="mb-4 last:mb-0"
              />
            </Table.Td>
            {((value?.length > 1) || allowDeleteLast) && <Table.Td width="40">
              <Button type="danger" onClick={() => {
                onChange(produce(value, draft => {
                  draft[index]['_destroy'] = true
                }))
              }}>
                <FontAwesomeIcon icon={icon({name: 'trash'})} />
              </Button>
            </Table.Td>}
          </Table.Row>
        })}
      </Table.Body>
    </Table>
  </>
}

function Select({onChange, value}) {

  const [defaultDestination, setDefaultDestination] = useState(null)
  const [allDestinations, fetchDestinations] = destinationStore(state => [state.collection, state.fetch])

  useEffect(() => {
    fetchDestinations()
  }, [fetchDestinations])

  const destinations = useMemo(() => {
    if (!allDestinations) return []
    return allDestinations.filter(d => {
      return !d.isArchived.toString().includes('1')
    })
  }, [allDestinations])

  useEffect(() => {
    if (!destinations) return
    setDefaultDestination(destinations.find((d) => d.value == value))
  }, [destinations, value])

  return (
    <div>
      <Select2
        isClearable
        options={destinations}
        onChange={onChange}
        menuPlacement="top"
        value={defaultDestination}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  )
}
